import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'
import 'firebase/auth'

// Set up our configuration data
const config = {
	apiKey: "AIzaSyCPa7O4ghBIn1x7pa2TQ0A37kpBZd2dHPk",
	authDomain: "classdoor-70e69.firebaseapp.com",
	databaseURL: "https://classdoor-70e69.firebaseio.com",
	projectId: "classdoor-70e69",
	storageBucket: "classdoor-70e69.appspot.com",
	messagingSenderId: "947277093575",
	appId: "1:947277093575:web:b013ec027bd6b5aa77bce2",
	measurementId: "G-E9D792JP57"
}


// Get a Firestore instance
const app = firebase.initializeApp(config);


// Export all the features we want to use
export const auth = app.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

export const firestore = app.firestore();